/**
 * Utility function to apply typography styles from backend data
 * @param {Object} typography - Typography object from backend
 * @param {string} element - Element type: 'h1', 'h2', 'h3', 'body', 'button'
 * @returns {Object} - Style object to apply
 */
export const applyTypographyStyle = (typography, element) => {
  if (!typography) return {};
  
  const styles = {};
  
  switch(element) {
    case 'h1':
      if (typography.h1_font) styles.fontFamily = typography.h1_font;
      if (typography.h1_size) styles.fontSize = typography.h1_size;
      if (typography.h1_color) styles.color = typography.h1_color;
      break;
    case 'h2':
      if (typography.h2_font) styles.fontFamily = typography.h2_font;
      if (typography.h2_size) styles.fontSize = typography.h2_size;
      if (typography.h2_color) styles.color = typography.h2_color;
      break;
    case 'h3':
      if (typography.h3_font) styles.fontFamily = typography.h3_font;
      if (typography.h3_size) styles.fontSize = typography.h3_size;
      if (typography.h3_color) styles.color = typography.h3_color;
      break;
    case 'body':
    case 'p':
      if (typography.body_font) styles.fontFamily = typography.body_font;
      if (typography.body_size) styles.fontSize = typography.body_size;
      if (typography.body_color) styles.color = typography.body_color;
      break;
    case 'button':
      if (typography.button_font) styles.fontFamily = typography.button_font;
      if (typography.button_size) styles.fontSize = typography.button_size;
      if (typography.button_color) styles.color = typography.button_color;
      break;
    default:
      break;
  }
  
  return styles;
};

/**
 * Get inline style string for direct HTML application
 */
export const getTypographyStyleString = (typography, element) => {
  const styles = applyTypographyStyle(typography, element);
  return Object.entries(styles)
    .map(([key, value]) => {
      // Convert camelCase to kebab-case
      const kebabKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      return `${kebabKey}: ${value}`;
    })
    .join('; ');
};
